<template>
    <a class="block block-rounded block-link-shadow block-bordered" href="javascript:void(0)">
        <div class="block-content block-content-full ribbon ribbon-bookmark" :class="{'ribbon-success': card.isVerified, 'ribbon-danger': !card.isVerified}">
            <div class="ribbon-box">{{ card.isVerified ? 'Active' : 'InActive'}}</div>
            <div class="py-2 text-center">
                <i class="fa fa-credit-card fa-4x text-gray"></i>
                <p class="font-size-lg text-black mt-2 mb-0">
                    {{card.name}}
                </p>
                <p class="text-muted mb-2">
                    {{card.pan.replace(/\./gi, 'x')}}
                </p>
                <p class="font-size-sm font-w700 text-muted mb-0">
                    {{card.brand}}
                </p>
            </div>
        </div>
        <div class="block-content block-content-full block-content-sm text-center bg-body-light">
            <em class="font-size-sm text-muted">Active through {{card.expiry}}</em>
        </div>
    </a>
</template>

<script>
    export default {
        props: {
            card: {
                type: Object
            }
        },

        name: "CreditCard"
    }
</script>

<style scoped>

</style>
